import React from 'react'
import Logo from '../Image/logo.png'
import './Style/Image.css'
function Image() {
  return <div className='logo'>

        <img className="img-thumbnail" src={Logo} alt=''/>
        <p className='p text-white company-name'> Company name </p>

  </div>
}

export default Image